<template>
  <div :class="classes" :style="styl"><slot></slot></div>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIXCLS = `${PREFIX_CLASS}col`

const ISVALIDGRID = function(value, start = 0, end = 12) {
  if (!Number.isInteger(value)) {
    return false
  } else {
    return value > start && value < end
  }
}

export default {
  name: 'TCol',
  props: {
    span: {
      // 栅格占位格数
      type: [Number, String],
      default: 0
    },
    offset: {
      // 栅格左侧的间隔格数，间隔内不可以有栅格
      type: [Number, String],
      default: 0,
      validator(value) {
        value = Number.parseInt(value)
        return ISVALIDGRID(value, -1)
      }
    },
    push: {
      type: [Number, String],
      default: 0,
      validator(value) {
        value = Number.parseInt(value)
        return ISVALIDGRID(value, -1, 13)
      }
    },
    pull: {
      type: [Number, String],
      default: 0,
      validator(value) {
        value = Number.parseInt(value)
        return ISVALIDGRID(value, -1, 13)
      }
    },
    xs: {
      type: [Number, String],
      default: 0
    },
    sm: {
      type: [Number, String],
      default: 0
    },
    md: {
      type: [Number, String],
      default: 0
    },
    lg: {
      type: [Number, String],
      default: 0
    },
    xl: {
      type: [Number, String],
      default: 0
    },
    align: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'start', 'center', 'end'].includes(value)
      }
    }
  },
  computed: {
    classes() {
      let _classes = []
      // 栅格占位
      const _sizeArr = ['span', 'xs', 'sm', 'md', 'lg', 'xl']
      _sizeArr.forEach(size => {
        if (this[size] && this.$_isValidSpan(this[size])) {
          if (size === 'span') {
            _classes.push(`${PREFIXCLS}-${this[size]}`)
          } else {
            _classes.push(`${PREFIXCLS}-${size}-${this[size]}`)
          }
        } else {
          if (size === 'span') {
            _classes.push(`${PREFIXCLS}`)
          } else {
            if (this[size] !== undefined && this[size] !== 0) {
              _classes.push(`${PREFIXCLS}-${size}`)
            }
          }
        }
      })

      // 向右偏移
      if (this.$_isValidOffset(this.offset) && this.offset > 0) {
        _classes.push(`offset-${this.offset}`)
      }

      // 向左移动
      if (this.$_isValidPull(this.pull) && this.pull > 0) {
        _classes.push(`pull-${this.pull}`)
      }

      // 向右移动
      if (this.$_isValidPush(this.push) && this.push > 0) {
        _classes.push(`push-${this.push}`)
      }
      // 垂直对齐
      if (this.align) {
        _classes.push(`align-self-${this.align}`)
      }
      return _classes.join(' ')
    },
    styl() {
      const _gutter = Number.parseInt(this.gutter)
      if (_gutter) {
        const _padding = `${this.gutter / 2}px`
        return {
          paddingLeft: _padding,
          paddingRight: _padding
        }
      }
      return {}
    },
    gutter() {
      let parent = this.$parent
      if (parent && parent.$options.name === 'TRow') {
        return parent.gutter
      } else {
        return null
      }
    }
  },
  methods: {
    // methods
    $_isValidSpan(value) {
      // 栅格占位格数, 1~12
      if (value === 'auto') {
        return true
      } else {
        value = Number.parseInt(value)
        return ISVALIDGRID(value, 0, 13)
      }
    },
    $_isValidOffset(value) {
      // 栅格左侧的间隔格数，间隔内不可以有栅格, 1~11
      value = Number.parseInt(value)
      return ISVALIDGRID(value)
    },
    $_isValidPush(value) {
      // 栅格向右移动格数, 0~12
      value = Number.parseInt(value)
      return ISVALIDGRID(value, -1, 13)
    },
    $_isValidPull(value) {
      // 栅格向左移动格数, 0~12
      value = Number.parseInt(value)
      return ISVALIDGRID(value, -1, 13)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/grid/col.vue